<template>
  <v-dialog v-model="model" max-width="420px">
    <v-card class="rounded-xl bg-surface border border-white-05">
      <v-card-title class="font-weight-black pa-4 pb-0 d-flex align-center justify-space-between">
        Settings
        <v-btn icon="mdi-close" variant="text" size="small" @click="model = false"></v-btn>
      </v-card-title>

      <v-card-text class="pa-4 pt-3">
        <v-list bg-color="transparent" class="pa-0">

          <!-- Theme -->
          <v-list-item class="px-0 rounded-lg">
            <template v-slot:prepend>
              <v-icon :icon="appTheme === 'dark' ? 'mdi-weather-night' : 'mdi-weather-sunny'" class="mr-3"></v-icon>
            </template>
            <v-list-item-title class="font-weight-bold">Theme</v-list-item-title>
            <v-list-item-subtitle class="text-caption">{{ appTheme === 'dark' ? 'Dark' : 'Light' }} mode</v-list-item-subtitle>
            <template v-slot:append>
              <v-btn-toggle
                v-model="appTheme"
                mandatory
                density="compact"
                variant="outlined"
                class="rounded-pill"
              >
                <v-btn value="dark" size="small" class="px-3">
                  <v-icon size="16" class="mr-1">mdi-weather-night</v-icon>
                  Dark
                </v-btn>
                <v-btn value="light" size="small" class="px-3">
                  <v-icon size="16" class="mr-1">mdi-weather-sunny</v-icon>
                  Light
                </v-btn>
              </v-btn-toggle>
            </template>
          </v-list-item>

          <v-divider class="my-2 border-white-05"></v-divider>

          <!-- Show Timeline -->
          <v-list-item class="px-0 rounded-lg">
            <template v-slot:prepend>
              <v-icon icon="mdi-timeline-outline" class="mr-3"></v-icon>
            </template>
            <v-list-item-title class="font-weight-bold">Show Timeline</v-list-item-title>
            <v-list-item-subtitle class="text-caption">Display Timeline in navigation</v-list-item-subtitle>
            <template v-slot:append>
              <v-switch
                v-model="showTimeline"
                color="primary"
                hide-details
                density="compact"
              ></v-switch>
            </template>
          </v-list-item>

        </v-list>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { showTimeline, appTheme } from '@/composables/useAppConfig';

const model = defineModel<boolean>();
</script>
